import * as React from 'react';
import { useState } from 'react';
import { format, startOfDay } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import * as Popover from '@radix-ui/react-popover';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

export function DateField({
  value,
  onChange,
  placeholder = 'Pick a date',
  className,
  minDate,
  disabled,
}) {
  const [open, setOpen] = useState(false);
  const min = minDate ? startOfDay(new Date(minDate)) : undefined;

  return (
    <Popover.Root open={open} onOpenChange={(v) => !disabled && setOpen(v)}>
      <Popover.Trigger asChild>
        <Button
          variant="outline"
          disabled={disabled}
          className={cn(
            'w-full justify-start text-left font-normal',
            !value && 'text-muted-foreground',
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {value ? format(new Date(value), 'PPP') : <span>{placeholder}</span>}
        </Button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          className="w-auto p-0 bg-popover border rounded-md shadow-md z-50"
          align="start"
        >
          <DayPicker
            mode="single"
            selected={value ? new Date(value) : undefined}
            disabled={min ? { before: min } : undefined}
            onSelect={(date) => {
              if (!date) return;
              if (min && startOfDay(date) < min) return;
              onChange(date);
              setOpen(false);
            }}
            className="p-3"
          />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
